<template>
  <div>
    <x-grid :id="'childGrid'"
            :columns="columns"
            :toolbar-config="toolbarConfig"
            :editable="true"
            :edit-rules="editRules"
            :editConfig="editConfig"
            ref="grid"
    >
      <template v-slot:[toolbarConfig.templatelSlots]>
        <vxe-button @click="visible = true">新增</vxe-button>
        <vxe-button @click="delRow()">删除</vxe-button>
      </template>
    </x-grid>

    <a-modal forceRender
             v-model="visible"
             title="选择角色"
             :width="800"
             ok-text="确认"
             cancel-text="取消"
             @ok="handleOk('roleTableModal')"
             @cancel="handleClose('roleTableModal')">
      <roleTableModal v-if="visible" ref="roleTableModal" @getTableData="getTableData"></roleTableModal>
    </a-modal>

  </div>
</template>

<script>
import XGrid from '@/components/grid/XGridChild'
import {GridChildMixin} from "@/utils/GridChildMixin";
import {
  formatter as fmt
} from "@/utils/ebase-formatter"
import {FormChildTable} from "@/utils/FormChildTable";

const fac = XGrid.factory;
console.info(fmt);//防止不使用便利 eslint报错

//弹出层组件
import roleTableModal from "@/pages/web/comm/userManage/detail/roleTableModal";

//列
const columns = [
  fac.makeColumnCheckboxDefault(),
  fac.makeColumn("roleName", "角色", 120),
  fac.makeColumn({
    field: "isMain",
    title: "默认角色",
    width: 140,
    align: 'center',
    editRender: {
      name: '$switch',
      defaultValue: 0,
      props: {
        'open-label': "是",
        'close-label': '否',
        'open-value': 1,
        'close-value': 0,
      },
    },
    formatter: fmt.formatYesNo
  }),
  fac.makeColumn({
    field: "remark",
    title: "描述",
    width: 300,
    editRender: {
      name: 'input',
    },
  }),
]

//可编辑表格规则 没有特殊要求的不改
const editRules = fac.makeEditRules(columns);

//工具栏按钮 没有可删除
const toolbarConfig = fac.makeToolbarConfig({
  templatelSlots: 'toolbarBtns'
});
//编辑配置
const editConfig = fac.makeEditConfig();

export default {
  mixins: [GridChildMixin],
  components: {
    roleTableModal
  },
  data() {
    return {
      toolbarConfig,
      editRules,
      columns,
      editConfig,
    }
  },
  methods: {
    /**
     * 方法名要与弹出层表格一致 建议固定
     * 获取子表弹出层的数据并插入子表
     * 调用FormChildTable.insertRow方法 将处理字段传入方法 对回调数据进行过滤或调整
     */
    getTableData(res, type) {
      switch (type) {
        case 'roleTable': {
          let dataArr = this.$refs['grid'].$refs['xGrid'].getTableData().fullData;
          //过滤子表中已有的数据
          let insertArr = FormChildTable.insertRow(this.$refs['grid'].$refs['xGrid'], res, 'roleId').map((item) => {
            return {
              isMain:dataArr.length?0:1,
              remark: item.remark,
              roleId: item.roleId,
              roleName: item.roleName,
            }
          });
          this.addRow(insertArr);
          break;
        }
        default:
          break
      }
    },
  }
}
</script>

<style scoped>
.vxe-toolbar {
  padding-left: 0
}
</style>